module.exports = __webpack_public_path__ + "img/mon_24.8c7f93c0.png";